import { render, staticRenderFns } from "./ArApp.vue?vue&type=template&id=64a402e6&scoped=true&"
var script = {}
import style0 from "./ArApp.vue?vue&type=style&index=0&id=64a402e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a402e6",
  null
  
)

export default component.exports